import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import ResourceProperty from '../../../../common/resource/ResourceProperty';
import DateCell from '../../../../common/cells/DateCell';
import LinkToModuleResource from '../../../../common/resource/LinkToModuleResource';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';
import { ROUTE_PATH, TOLL_PATH } from '../../../../../config/paths';

const getValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  return value;
};

const TollExtraordinaryAssignmentBasicInformationResource = ({
  id,
  serviceType,
  routeId,
  routeName,
  startDate,
  endDate,
  tolls,
  userFullName,
  createDate,
}) => (
  <Fragment>
    <ResourceProperty label="ID:">{getValue(id)}</ResourceProperty>

    <ResourceProperty label="Tipo de Servicio:">
      {serviceType && serviceType.name ? serviceType.name : '-'}
    </ResourceProperty>

    <ResourceProperty label="Ruta:">
      {routeId ? (
        <LinkToModuleResource
          text={routeName}
          href={`${ROUTE_PATH}/${routeId}`}
          isExternalPath
        />
      ) : (
        '-'
      )}
    </ResourceProperty>

    <ResourceProperty label="Fecha Inicial:">
      {startDate ? <DateCell value={startDate} /> : '-'}
    </ResourceProperty>

    <ResourceProperty label="Fecha Final:">
      {endDate ? <DateCell value={endDate} /> : '-'}
    </ResourceProperty>

    <ResourceProperty label="Peajes Extraordinarios:">
      {tolls && tolls.length
        ? tolls.map(({ id: tollId, name }, index) => (
            <Fragment key={tollId}>
              {index > 0 && ', '}
              <LinkToModuleResource
                text={name}
                href={`${TOLL_PATH}/${tollId}`}
                isExternalPath
              />
            </Fragment>
          ))
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Creado por:">
      {getValue(userFullName)}
    </ResourceProperty>

    <ResourceProperty label="Fecha de Registro:">
      {createDate ? (
        <DateCell value={createDate} format={DATE_TIME_FORMAT} />
      ) : (
        '-'
      )}
    </ResourceProperty>
  </Fragment>
);

TollExtraordinaryAssignmentBasicInformationResource.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  serviceType: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
  }),
  routeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  routeName: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  tolls: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
    }),
  ),
  userFullName: PropTypes.string,
  createDate: PropTypes.string,
};

TollExtraordinaryAssignmentBasicInformationResource.defaultProps = {
  id: null,
  serviceType: null,
  routeId: null,
  routeName: null,
  startDate: null,
  endDate: null,
  tolls: [],
  userFullName: null,
  createDate: null,
};

export default TollExtraordinaryAssignmentBasicInformationResource;
